var _rect, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCommunicationServices = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#EDEFF2",
    rx: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.159,
    cy: 12.64,
    r: 1.76,
    fill: "#475E7B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#475E7B",
    d: "M15.68 12.8h.96l1.347 11.055a1.842 1.842 0 1 1-3.656 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#475E7B",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M19.36 9.44a4.526 4.526 0 0 1 0 6.4m-6.4 0a4.526 4.526 0 0 1 0-6.4M21.477 7.322a7.52 7.52 0 0 1 0 10.635m-10.635 0a7.52 7.52 0 0 1 0-10.635"
  })));
};
export default SvgCommunicationServices;